function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThingsAndStuff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.511,1.762C25.052,0.988 24.206,0.513 23.304,0.513C22.401,0.513 21.555,0.988 21.096,1.762L13.362,14.651C12.887,15.449 12.871,16.44 13.33,17.245C13.789,18.051 14.643,18.55 15.57,18.55L31.037,18.55C31.964,18.55 32.826,18.051 33.277,17.245C33.728,16.44 33.72,15.449 33.245,14.651L25.511,1.762ZM23.304,25.648L23.304,37.249C23.304,39.029 24.746,40.471 26.526,40.471L38.127,40.471C39.907,40.471 41.349,39.029 41.349,37.249L41.349,25.648C41.349,23.867 39.907,22.425 38.127,22.425L26.526,22.425C24.746,22.425 23.304,23.867 23.304,25.648ZM10.414,41.76C16.109,41.76 20.726,37.144 20.726,31.448C20.726,25.753 16.109,21.136 10.414,21.136C4.718,21.136 0.102,25.753 0.102,31.448C0.102,37.144 4.718,41.76 10.414,41.76Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThingsAndStuff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/things-and-stuff.e341976f8d8faf5517d1b1aca8b85b42.svg";